<template>
  <div>
    <v-navigation-drawer  v-if="isConnected" v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <v-list dense>
        <v-list-group v-for="menu in this.menusFilterAccess" :key="menu.titre">
            <template v-slot:activator>
              <v-list-item-action >
                <v-icon v-if="menuParentActiv(menu)" color="primary">{{ menu.logo }}</v-icon>
                <v-icon v-else >{{ menu.logo }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  <span v-if="menuParentActiv(menu)" class="primary--text">{{ $t(menu.titre) }}</span>
                  <span v-else >{{ $t(menu.titre) }}</span>
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list class="secondary sub_menu">
              <v-list-item v-for="submenu in menu.children" :key="submenu.titre">
                <v-list-item-action>
                  <v-icon v-if="menuActiv(submenu)" color="primary">{{ submenu.logo }}</v-icon>
                  <v-icon v-else >{{ submenu.logo }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    <router-link v-if="menuHasAccess(submenu)" class="routerLink" :to="{ name: submenu.route }" >
                      <span v-if="menuActiv(submenu)" class="primary--text">{{ $t(submenu.titre) }}</span>
                      <span v-else >{{ $t(submenu.titre) }}</span>
                    </router-link>
                    <span v-else class="routerLinkForbidden" >{{ $t(submenu.titre) }}</span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="darken-3" dark>
      <template v-if="isConnected"><v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon></template>
      <v-toolbar-title
        class="ml-0 pl-4"
      >
        <v-img
          class="hidden-xs-and-down mx-2 cursorpointer"
          src="@/assets/logo_dark.png"
          alt="LynxHub"
          position="Left"
          max-height="32"
          max-width="100"
          contain
          @click="toHome"
          @click.right="toGif"
        ></v-img>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <template v-if="isConnected">
        <NotificationNavigation ref="NotificationNavigation" />
        <ProfilNavigation ref="ProfilNavigation" />
       </template>
       <v-divider inset vertical ></v-divider>
       <LanguageNavigation ref="LanguageNavigation" />
    </v-app-bar>
  </div>
</template>

<script>

import NotificationNavigation from '../notification/Navigation.vue';
import ProfilNavigation from '../profil/Navigation.vue';
import LanguageNavigation from '../home/LanguageNavigation.vue';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'Navigation',
  mixins: [AccessMixin],
  components: {
    NotificationNavigation,
    ProfilNavigation,
    LanguageNavigation,
  },
  props: {
    isConnected: {
      type: Boolean,
      required: true
    },

  },


  data: () => ({
    drawer: null,
    menus : [
      {
        titre: 'menu.production',
        logo: 'mdi-rocket-launch',
        access : ['product_read','distributor_read'],
        children: [
          {
            titre: 'qualitycheck.product.products',
            logo: 'mdi-purse',
            route: 'ProductList',
            access : ['product_read'],
          },
          {
            titre: 'qualitycheck.distributor.distributors',
            logo: 'mdi-account-child',
            route: 'DistributorList',
            access : ['distributor_read'],
          },
        ]
      },
      {
        titre: 'menu.qualitycheck',
        logo: 'mdi-book-check',
        access : ['qualitycheck_read','qualitychecktest_read'],
        children: [
          /*{
            titre: 'global.dashboard',
            logo: 'mdi-bug-check',
            route: 'QualityCheckSpecList',
            access : ['qualitycheck_read'],
          },*/
          {
            titre: 'qualitycheck.qualitycheck.history',
            logo: 'mdi-bug-check',
            route: 'QualityCheckList',
            access : ['qualitycheck_read'],
          },
          {
            titre: 'qualitycheck.test.tests',
            logo: 'mdi-bug-check',
            route: 'QualityCheckTestList',
            access : ['qualitychecktest_read'],
          },
        ]
      },
      {
        titre: 'menu.sav',
        logo: 'mdi-ticket',
        access : ['customer_read','ticket_read','ticketaction_read','contract_read'],
        children: [
          {
            titre: 'qualitycheck.customer.customers',
            logo: 'mdi-account-cash',
            route: 'CustomerList',
            access : ['customer_read'],
          },
          {
            titre: 'contact.contacts',
            logo: 'mdi-account-cash',
            route: 'ContactList',
            access : ['contact_read'],
          },
          {
            titre: 'ticket.tickets',
            logo: 'mdi-ticket',
            route: 'TicketList',
            access : ['ticket_read'],
          },
          {
            titre: 'ticket.ticketactions',
            logo: 'mdi-ticket',
            route: 'TicketactionList',
            access : ['ticketaction_read'],
          },
          {
            titre: 'contract.contracts',
            logo: 'mdi-gavel',
            route: 'ContractList',
            access : ['contract_read'],
          },
        ]
      },
      {
        titre: 'menu.product',
        logo: 'mdi-printer-3d',
        access : ['machine_read','materialsupply_read','toolhead_read','accessory_read'
        ,'controlunit_read','industrialcomputer_read','softwareversion_read','printingsurface_read','operatingsystem_read','nozzle_read'
        ,'tool_read','option_read','producttypefile_read'],
        children: [
          {
            titre: 'profile.machine.machines',
            logo: 'mdi-printer-3d',
            route: 'MachineList',
            access : ['machine_read'],
          },
          {
            titre: 'profile.tool.toolheads',
            logo: 'mdi-tools',
            route: 'ToolHeadList',
            access : ['toolhead_read'],
          },
          {
            titre: 'profile.accessory.accessories',
            logo: 'mdi-cctv',
            route: 'AccessoryList',
            access : ['accessory_read'],
          },
          {
            titre: 'profile.option.options',
            logo: 'mdi-toy-brick-plus',
            route: 'OptionList',
            access : ['option_read'],
          },
          {
            titre: 'profile.material.supplies',
            logo: 'mdi-format-color-fill',
            route: 'MaterialSupplyList',
            access : ['materialsupply_read'],
          },
          {
            titre: 'profile.controlunit.controlunits',
            logo: 'mdi-car-cruise-control',
            route: 'ControlUnitList',
            access : ['controlunit_read'],
          },
          {
            titre: 'profile.industrialcomputer.industrialcomputers',
            logo: 'mdi-server',
            route: 'IndustrialComputerList',
            access : ['industrialcomputer_read'],
          },
          {
            titre: 'profile.operatingsystem.operatingsystems',
            logo: 'mdi-microsoft-windows',
            route: 'OperatingSystemList',
            access : ['operatingsystem_read'],
          },
          {
            titre: 'profile.software.versions',
            logo: 'mdi-apps',
            route: 'SoftwareVersionList',
            access : ['softwareversion_read'],
          },
          {
            titre: 'profile.tool.tools',
            logo: 'mdi-tools',
            route: 'ToolList',
            access : ['tool_read'],
          },
          {
            titre: 'profile.nozzle.nozzles',
            logo: 'mdi-printer-3d-nozzle',
            route: 'NozzleList',
            access : ['nozzle_read'],
          },
          {
            titre: 'profile.printingsurface.printingsurfaces',
            logo: 'mdi-checkerboard',
            route: 'PrintingSurfaceList',
            access : ['printingsurface_read'],
          },
          {
            titre: 'version.changelog.changelogs',
            logo: 'mdi-math-log',
            route: 'ChangeLogList',
            access : ['changelog_read'],
          },
          {
            titre: 'qualitycheck.product.producttypefiles',
            logo: 'mdi-file-document-edit-outline',
            route: 'ProducttypefileList',
            access : ['producttypefile_read'],
          },
        ]
      },
      {
        titre: 'profile.material.materials',
        logo: 'mdi-format-color-fill',
        access : ['material_read','materialcolor_read','materialfeedspec_read','materialmanufacturer_read','materialmedium_read','materialstate_read','materialtype_read','materialproduct_read','materialproductversion_read','materialproductlot_read'],
        children: [
          {
            titre: 'profile.material.colors',
            logo: 'mdi-format-color-fill',
            route: 'MaterialColorList',
            access : ['materialcolor_read'],
          },
          {
            titre: 'profile.material.materials',
            logo: 'mdi-format-color-fill',
            route: 'MaterialList',
            access : ['material_read'],
          },
/*
          {
            titre: 'profile.material.feedspecs',
            logo: 'mdi-format-color-fill',
            route: 'MaterialFeedSpecList',
            access : ['materialfeedspec_read'],
          },
          */
          {
            titre: 'profile.material.manufacturers',
            logo: 'mdi-format-color-fill',
            route: 'MaterialManufacturerList',
            access : ['materialmanufacturer_read'],
          },
          {
            titre: 'profile.material.mediums',
            logo: 'mdi-format-color-fill',
            route: 'MaterialMediumList',
            access : ['materialmedium_read'],
          },
          /*
          {
            titre: 'profile.material.states',
            logo: 'mdi-format-color-fill',
            route: 'MaterialStateList',
            access : ['materialstate_read'],
          },
          */
          {
            titre: 'profile.material.types',
            logo: 'mdi-format-color-fill',
            route: 'MaterialTypeList',
            access : ['materialtype_read'],
          },
          {
            titre: 'profile.material.products',
            logo: 'mdi-qrcode',
            route: 'MaterialProductList',
            access : ['materialproduct_read'],
          },
          {
            titre: 'profile.material.productversions',
            logo: 'mdi-qrcode',
            route: 'MaterialProductVersionList',
            access : ['materialproductversion_read'],
          },
          {
            titre: 'profile.material.productlots',
            logo: 'mdi-qrcode',
            route: 'MaterialProductLotList',
            access : ['materialproductlot_read'],
          },
        ]
      },
      {
        titre: 'menu.profile',
        logo: 'mdi-file-cog',
        access : ['profilefile_read','profileparameterset_read','profilestrategy_read','setupdefinition_read'],
        children: [
          {
            titre: 'profile.profilefiles',
            logo: 'mdi-file-cog-outline',
            route: 'ProfileFileList',
            access : ['profilefile_read'],
          },
          /*{
            titre: 'profile.profilefilesutils',
            logo: 'mdi-file-cog-outline',
            route: 'ProfileFileUtils',
            access : ['profilefile_edit'],
          },*/
          /*
          {
            titre: 'profile.profileparameter.sets',
            logo: 'mdi-file-cog-outline',
            route: 'ProfileParameterSetList',
            access : ['profileparameterset_read'],
          },
          {
            titre: 'profile.strategy.strategies',
            logo: 'mdi-strategy',
            route: 'ProfileStrategyList',
            access : ['profilestrategy_read'],
          },
          {
            titre: 'profile.setupdefinition.definitions',
            logo: 'mdi-clipboard-list',
            route: 'SetupDefinitionList',
            access : ['setupdefinition_read'],
          },
          */
        ]
      },
      {
        titre: 'menu.documentation',
        logo: 'mdi-certificate',
        access : ['process_read','processschema_read'],
        children: [
          {
            titre: 'process.documentations',
            logo: 'mdi-book',
            route: 'ProcessListType',
            access : ['process_read'],
          },
          {
            titre: 'process.documentationsadmin',
            logo: 'mdi-book-search-outline',
            route: 'ProcessList',
            access : ['process_edit'],
          },

          
          {
            titre: 'process.processesschema',
            logo: 'mdi-vector-polyline',
            route: 'ProcessSchemaList',
            access : ['processschema_read'],
          },

        ]
      },
      {
        titre: 'article.articles',
        logo: 'mdi-newspaper',
        access : ['article_read'],
        children: [
          {
            titre: 'article.articles',
            logo: 'mdi-newspaper',
            route: 'ArticleList',
            access : ['article_read'],
          },
        ]
      },
      {
        titre: 'designfile.designfiles',
        logo: 'mdi-file-cad',
        access : ['designfile_read','designfiletype_read'],
        children: [
        {
            titre: 'designfile.designfiles',
            logo: 'mdi-file-cad',
            route: 'DesignFileList',
            access : ['designfile_read'],
          },
          {
            titre: 'designfile.designfiletypes',
            logo: 'mdi-file-cad',
            route: 'DesignFileTypeList',
            access : ['designfiletype_read'],
          },
        ]
      },




      {
        titre: 'profile.parameter',
        logo: 'mdi-table-cog',
        access : ['score_read','profilebenchmark_read','profiletool_read','quality_read','qualityfocus_read','qualitylayer_read','productstatus_read','qualitycheckvaluetype_read','sectionparameter_read','profileparameter_read','machinemodel_read','toolextruder_read','toolheater_read','nozzlein_read','nozzleout_read','nozzlemanufacturer_read'
        ,'nozzlematerial_read','nozzletype_read','nozzlevisual_read','printingsurfacematerial_read','printingsurfacesize_read','printingsurfacethickness_read','software_read','actiontype_read','bugtype_read','ticketorigin_read','ticketstatus_read','priority_read','contracttype_read','producttypefiletype_read','service_read','macrotype_read','processtype_read'],
        children: [
          /*
          {
            titre: 'profile.score.scores',
            logo: 'mdi-podium',
            route: 'ScoreList',
            access : ['score_read'],
          },
          {
            titre: 'profile.score.benchmarks',
            logo: 'mdi-podium',
            route: 'ProfileBenchmarkList',
            access : ['profilebenchmark_read'],
          },
          {
            titre: 'profile.score.tools',
            logo: 'mdi-podium',
            route: 'ProfileToolList',
            access : ['profiletool_read'],
          },

          {
            titre: 'profile.quality.qualities',
            logo: 'mdi-quality-high',
            route: 'QualityList',
            access : ['quality_read'],
          },
          */
          {
            titre: 'profile.quality.focus',
            logo: 'mdi-quality-high',
            route: 'QualityFocusList',
            access : ['qualityfocus_read'],
          },
          {
            titre: 'profile.quality.layers',
            logo: 'mdi-quality-high',
            route: 'QualityLayerList',
            access : ['qualitylayer_read'],
          },
          {
            titre: 'qualitycheck.product.status',
            logo: 'mdi-purse',
            route: 'ProductStatusList',
            access : ['productstatus_read'],
          },
          {
            titre: 'qualitycheck.value.types',
            logo: 'mdi-bug-check',
            route: 'QualityCheckValueTypeList',
            access : ['qualitycheckvaluetype_read'],
          },
          /*
          {
            titre: 'profile.sectionparameter.sectionparameters',
            logo: 'mdi-file-cog-outline',
            route: 'SectionParameterList',
            access : ['sectionparameter_read'],
          },
          {
            titre: 'profile.profileparameter.parameters',
            logo: 'mdi-file-cog-outline',
            route: 'ProfileParameterList',
            access : ['profileparameter_read'],
          },
          */
          {
            titre: 'profile.machine.models',
            logo: 'mdi-printer-3d',
            route: 'MachineModelList',
            access : ['machinemodel_read'],
          },
          {
            titre: 'profile.tool.extruders',
            logo: 'mdi-tools',
            route: 'ToolExtruderList',
            access : ['toolextruder_read'],
          },
          {
            titre: 'profile.tool.heaters',
            logo: 'mdi-tools',
            route: 'ToolHeaterList',
            access : ['toolheater_read'],
          },
          {
            titre: 'profile.nozzle.nozzlesin',
            logo: 'mdi-printer-3d-nozzle',
            route: 'NozzleInList',
            access : ['nozzlein_read'],
          },
          {
            titre: 'profile.nozzle.nozzlesout',
            logo: 'mdi-printer-3d-nozzle',
            route: 'NozzleOutList',
            access : ['nozzleout_read'],
          },
          {
            titre: 'profile.nozzle.manufacturers',
            logo: 'mdi-printer-3d-nozzle',
            route: 'NozzleManufacturerList',
            access : ['nozzlemanufacturer_read'],
          },
          {
            titre: 'profile.nozzle.materials',
            logo: 'mdi-printer-3d-nozzle',
            route: 'NozzleMaterialList',
            access : ['nozzlematerial_read'],
          },
          {
            titre: 'profile.nozzle.types',
            logo: 'mdi-printer-3d-nozzle',
            route: 'NozzleTypeList',
            access : ['nozzletype_read'],
          },
          {
            titre: 'profile.nozzle.visuals',
            logo: 'mdi-printer-3d-nozzle',
            route: 'NozzleVisualList',
            access : ['nozzlevisual_read'],
          },
          {
            titre: 'profile.printingsurface.materials',
            logo: 'mdi-checkerboard',
            route: 'PrintingSurfaceMaterialList',
            access : ['printingsurfacematerial_read'],
          },
          {
            titre: 'profile.printingsurface.sizes',
            logo: 'mdi-checkerboard',
            route: 'PrintingSurfaceSizeList',
            access : ['printingsurfacesize_read'],
          },
          {
            titre: 'profile.printingsurface.thickness',
            logo: 'mdi-checkerboard',
            route: 'PrintingSurfaceThicknessList',
            access : ['printingsurfacethickness_read'],
          },
          {
            titre: 'profile.software.softwares',
            logo: 'mdi-apps',
            route: 'SoftwareList',
            access : ['software_read'],
          },
          {
            titre: 'ticket.actiontypes',
            logo: 'mdi-ticket',
            route: 'ActiontypeList',
            access : ['actiontype_read'],
          },
          {
            titre: 'ticket.bugtypes',
            logo: 'mdi-ticket',
            route: 'BugtypeList',
            access : ['bugtype_read'],
          },
          {
            titre: 'ticket.ticketorigin',
            logo: 'mdi-ticket',
            route: 'TicketoriginList',
            access : ['ticketorigin_read'],
          },
          {
            titre: 'ticket.ticketstatus',
            logo: 'mdi-ticket',
            route: 'TicketstatusList',
            access : ['ticketstatus_read'],
          },
          {
            titre: 'priority.priorities',
            logo: 'mdi-priority-high',
            route: 'PriorityList',
            access : ['priority_read'],
          },
          {
            titre: 'ticket.tags',
            logo: 'mdi-tag',
            route: 'TagList',
            access : ['tag_read'],
          },
          {
            titre: 'contract.contracttypes',
            logo: 'mdi-gavel',
            route: 'ContracttypeList',
            access : ['contracttype_read'],
          },
          {
            titre: 'qualitycheck.product.producttypefiletypes',
            logo: 'mdi-file-document-edit-outline',
            route: 'ProducttypefiletypeList',
            access : ['producttypefiletype_read'],
          },
          {
            titre: 'service.services',
            logo: 'mdi-account-group',
            route: 'ServiceList',
            access : ['service_read'],
          },
          {
            titre: 'macro.macrotypes',
            logo: 'mdi-file-code',
            route: 'MacroTypeList',
            access : ['macrotype_read'],
          },
          {
            titre: 'process.documentationtype',
            logo: 'mdi-book',
            route: 'ProcessTypeList',
            access : ['processtype_read'],
          },
        ]
      },
      {
        titre: 'administration.administration',
        logo: 'mdi-account-cog',
        access : ['user_read','profil_read','security_parameter_read','connexion_user_read','forgot_password_read','profilinterface_read','application_read','backup_read'],
        children: [
          {
            titre: 'administration.user.users',
            logo: 'mdi-account',
            route: 'UserList',
            access : ['user_read'],
          },
          {
            titre: 'administration.profil.profils',
            logo: 'mdi-account-group',
            route: 'ProfilUserList',
            access : ['profil_read'],
          },
          {
            titre: 'administration.profil.profilinterfaces',
            logo: 'mdi-account-box-multiple',
            route: 'ProfilInterfaceList',
            access : ['profilinterface_read'],
          },
          {
            titre: 'app.apps',
            logo: 'mdi-apps',
            route: 'ApplicationList',
            access : ['application_read'],
          },
          {
            titre: 'app.connectors',
            logo: 'mdi-update',
            route: 'ApplicationConnectorList',
            access : ['application_read'],
          },
          {
            titre: 'administration.securityparameter.securityparameters',
            logo: 'mdi-account-cog',
            route: 'SecurityParameterList',
            access : ['security_parameter_read'],
          },
          {
            titre: 'administration.user.connexionusers',
            logo: 'mdi-login',
            route: 'ConnexionUserList',
            access : ['connexion_user_read'],
          },
          {
            titre: 'administration.user.forgotpasswords',
            logo: 'mdi-account-convert',
            route: 'ForgotPasswordList',
            access : ['forgot_password_read'],
          },
          {
            titre: 'administration.backup.backups',
            logo: 'mdi-content-save-all',
            route: 'BackupList',
            access : ['backup_read'],
          },
        ]
      },
    ]
  }),
  methods: {
    refreshPage() {
      console.log("refreshPage");
      window.location.reload(false);
    },
    toHome() {
      if (this.$root.isConnected) {
        this.$router.push({ name: `Home` });
      }
    },
    toGif() {
      if (this.$root.isConnected) {
        this.$router
          .push({ name: `GifList` })
          .catch(() => {});
      }
    },
    menuActiv(menu) {
      if(menu) {
        let route = this.$route.name;
        route = route.replace("Show", "List");
        route = route.replace("Create", "List");
        route = route.replace("Update", "List");
        route = route.replace("Delete", "List");
        route = route.replace("Enable", "List");
        route = route.replace("Valid", "List");

        if(route == menu.route ) {
          return true;
        }

      }
      return false;
    },
    menuParentActiv(menu) {
      if(menu.children) {
        let route = this.$route.name;
        route = route.replace("Show", "List");
        route = route.replace("Create", "List");
        route = route.replace("Update", "List");
        route = route.replace("Delete", "List");
        route = route.replace("Enable", "List");
        route = route.replace("Valid", "List");
        for (var i = 0; i < menu.children.length; i++) {

          if(menu.children[i].route == route ) {
            return true;
          }
        }
      }
      return false;
    }

  },
  mounted() {

  },
  computed: {

  },
  watch: {

  }
};
</script>
